import { find } from "lodash";
import { BettingInterest, RaceProgram } from "@tvg/ts-types/Race";
import { isBiScratched } from "@tvg/desktop-bet/src/utils/betUtils";

const getLegBets = (
  selections: string[][],
  biNumber: string,
  position: number,
  race: RaceProgram,
  races: RaceProgram[]
) => {
  const currentSelections = [...selections];

  if (biNumber === "all") {
    const indexOfRace = races.findIndex(
      (element: RaceProgram) => element.id === race.id
    );
    const selectedRace = races[indexOfRace + position];
    const notScratchedRunnerAvailable =
      selectedRace?.bettingInterests?.reduce(
        (acc: string[], bi: BettingInterest) => {
          if (isBiScratched(bi) === false) {
            acc.push(`${bi.biNumber}`);
          }
          return acc;
        },
        []
      ) || [];

    const leg = [...currentSelections[position]] || [];

    if (leg.length >= notScratchedRunnerAvailable.length) {
      currentSelections[position] = [];
    } else {
      currentSelections[position] = notScratchedRunnerAvailable;
    }
  } else {
    let leg = [...currentSelections[position]] || [];
    if (find(leg, (value: string) => value === biNumber)) {
      leg = leg.filter((value) => value !== biNumber);
    } else {
      leg.push(biNumber);
    }

    currentSelections[position] = leg;
  }

  return currentSelections;
};

export default getLegBets;
